<template>
  <v-container>
    <v-row class="mb-6" no-gutters>
      <h1 class="accent--text">Dashboard</h1>
    </v-row>
    <v-row>
      <v-col cols="12" md="9">
        <v-row no-gutters>
          <v-tabs color="accent" background-color="transparent">
            <v-tab class="tab" href="#mill">
              Mill
            </v-tab>
            <v-tab-item value="mill">
              <CurrentCards />
            </v-tab-item>

            <v-tab class="tab" href="#garage">
              Garage
            </v-tab>
            <v-tab-item value="garage">
              <GarageCards />
            </v-tab-item>
          </v-tabs>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="ma-2 rounded-xl" flat color="primary" outlined>
              <v-tabs background-color="primary" color="white" dark grow>
                <v-tab>Temp</v-tab>
                <v-tab>Humidity</v-tab>
                <v-tab>Pressure</v-tab>

                <v-tab-item
                  class="rounded-xl"
                  style="background-color: #6578b4"
                >
                  <Chart
                    :history="history"
                    :chartArray="chartArray"
                    type="temperature"
                  />
                </v-tab-item>
                <v-tab-item
                  class="rounded-xl"
                  style="background-color: #6578b4"
                >
                  <Chart
                    :history="history"
                    :chartArray="chartArray"
                    type="humidity"
                  />
                </v-tab-item>
                <v-tab-item
                  class="rounded-xl"
                  style="background-color: #6578b4"
                >
                  <Chart
                    :history="history"
                    :chartArray="chartArray"
                    type="pressure"
                  />
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3">
        <v-row>
          <v-col>
            <FlyTrap :flyTrap="flyTrap" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <WaterTank :waterTank="waterTank" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import CurrentCards from "@/components/CurrentCards";
import GarageCards from "@/components/GarageCards";
import FlyTrap from "@/components/FlyTrap";
import WaterTank from "@/components/WaterTank";
import Chart from "@/components/Chart";

export default {
  name: "Dashboard",
  components: {
    CurrentCards,
    GarageCards,
    Chart,
    FlyTrap,
    WaterTank,
  },
  data() {
    return {
      step: 1,
      toggle_exclusive: 0,
    };
  },
  computed: {
    ...mapState({
      btnLoading: (state) => state.btnLoading,
      current: (state) => state.mill.current,
      garage: (state) => state.mill.garage,
      flyTrap: (state) => state.mill.flyTrap,
      waterTank: (state) => state.mill.waterTank,
      history: (state) => state.mill.history,
      chartArray: (state) => state.mill.chartData,
    }),
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Mill";
        default:
          return "Garage";
      }
    },
    currentIcon() {
      switch (this.step) {
        case 1:
          return "mdi-hydro-power";
        default:
          return "mdi-garage-variant";
      }
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("fetchCurrent");
      await this.$store.dispatch("fetchGarage");
      await this.$store.dispatch("fetchFlytrap");
      await this.$store.dispatch("fetchWaterTank");
      await this.$store.dispatch("fetchHistory");
      await this.$store.dispatch("fetchChartData");
    } catch {
      alert("error");
    }
  },
  methods: {},
};
</script>

<style scoped>
.radius {
  border-radius: 25px !important;
}

.tab {
  font-weight: 900 !important;
}
</style>
